import { ColumnOptionsBase, ServerSideColumnOption } from '../types/column-options';
import { DateTimeColumn } from '../types/grid';
import { IsoDateTime, IsoDateTimeTz } from '@softline/core';
import { EntityColumnRef, GridRef, GroupColumnRef } from '../types/refs';

export interface DateTimeColumnOptions<TRow extends object, TValue extends IsoDateTime | IsoDateTimeTz> extends ColumnOptionsBase<TRow, TValue> {
  format?: string;
}
export type ServerSideDateTimeColumnOptions<TRow extends object, TValue extends IsoDateTime | IsoDateTimeTz> = DateTimeColumnOptions<TRow, TValue> & ServerSideColumnOption;

export function dateTimeColumn<TRow extends object, TValue extends IsoDateTime | IsoDateTimeTz>(ref: GridRef<TRow> | GroupColumnRef<TRow> | EntityColumnRef<TRow>,
                                                options: DateTimeColumnOptions<TRow, TValue> | ServerSideDateTimeColumnOptions<TRow, TValue>): DateTimeColumn<TRow, TValue> {
  const column: DateTimeColumn<TRow, TValue> = {
    ...options,
    type: 'dateTime',
    format: options.format ?? 'DATE_TIME.DEFAULT'
  }
  ref.createColumn(column as any);
  return column;
}
